import { render, staticRenderFns } from "./LaunchingTouch.vue?vue&type=template&id=9a454e0a&scoped=true&"
var script = {}
import style0 from "./LaunchingTouch.vue?vue&type=style&index=0&id=9a454e0a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a454e0a",
  null
  
)

export default component.exports